import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

import 'font-awesome/css/font-awesome.css';
import 'animate.css/animate.css';
import 'jquery.scrollto';
import './static/css/sandosFont.css';
import './static/less/global/bookingengine.less';
import './static/images/loading5.gif';
import './static/images/loading.gif';
//import './styles/main.css';
import './styles/mainOriginal.css';
//Usaremos el main.css del proyecto original antes de actualizarlo porque al actualizar las librerías se genera un main.css diferente donde algunas clases ya no están

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import {
  BrowserRouter as Router, Route, Routes, Navigate,
} from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './Store';

import Base from './components/Base';
import Search from './components/Search';
import Home from './components/Home';
import Hotels from './components/booking/hotels/Hotels';
import RoomList from './components/booking/rooms/RoomList';
import CartRooms from './components/booking/confirmation/CartRooms';
import CartShare from './components/share/CartShare';
import Error from './components/Error';
import Thanks from './components/booking/confirmation/Thanks';
import MyBooking from './components/booking/mybooking/MyBooking';
import LoginForm from './components/user/LoginForm';
import PasswordReset from './components/user/PasswordReset';
import PasswordResetToken from './components/user/PasswordResetToken';
import Cancellation from './components/booking/cancellation/Cancellation';
import BookingDetails from './components/booking/mybooking/BookingDetails';
import TestPage from './components/ds/pages/TESTCOMPONENTS';
import Payment from './components/booking/payment/Payment';
import PaymentUpfront from './components/booking/payment/PaymentUpfront';
import Policy from './components/booking/Policy';
import FreeMode from './components/booking/free-mode/FreeMode';
import ExtrasList from './components/booking/extras/ExtrasList';
import Budget from './components/booking/budget/Budget';
import BookingDetailsPrev from './components/booking/mybooking/BookingDetailsPrev';

const App = () =>
// Añade aquí cualquier lógica necesaria para seguimiento de navegación

  (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Base>
            <Routes>
                {/* eslint-disable max-len */}
                <Route path="/" element={<Home />} />
                <Route path="/error/" element={<Error />} />
                <Route path="/v3/search/:lang/:origin/:session/:checkIn/:checkOut/:destType/:destId/:distributions/:agentCode/:rateType/:agentSell" element={<Search />} />
                <Route path="/v3/search/:lang/:origin/:session/:checkIn/:checkOut/:destType/:destId/:distributions/:agentCode/:rateType/:agentSell/:promoCode" element={<Search />} />
                <Route path="/autogenerate-search/:lang/:origin/:daysFromCheckIn/:daysFromCheckOut/:destType/:destId/:distributions/" element={<Search />} />
                <Route path="/autogenerate-search/:lang/:origin/:daysFromCheckIn/:daysFromCheckOut/:destType/:destId/:distributions/:promoCode/" element={<Search />} />
                <Route path="/hotels/" element={<Hotels />} />
                <Route path="/rooms/" element={<RoomList />} />
                <Route path="/all-rooms/" element={<FreeMode />} />
                <Route path="/confirmation/" element={<CartRooms />} />
                <Route path="/cart-share/:token/" element={<CartShare />} />
                <Route path="/cart-share/:lang/:token/" element={<CartShare />} />
                <Route path="/thanks/:locator?/:email?/:lang?" element={<Thanks />} />
                <Route path="/booking-detail/:locator?/:email?/:lang?" element={<BookingDetails />} />
                <Route path="/booking-detail-v1/:locator?/:email?/:lang?" element={<BookingDetailsPrev />} />
                <Route path="/callcenter/login/" element={<LoginForm />} />
                <Route path="/password/reset/" element={<PasswordReset />} />
                <Route path="/password/reset/:uid/:token/" element={<PasswordResetToken />} />
                <Route path="/my-booking/:lang?/:chain?" element={<MyBooking />} />
                <Route path="/cancellation/" element={<Cancellation />} />
                <Route path="/payment-upfront/:token/:lang?" element={<PaymentUpfront />} />
                <Route path="/payment/:locator/:email/:chain?" element={<Payment />} />
                <Route path="/policies/:hotelId/:lang/:chain?" element={<Policy />} />
                <Route path="/select-extra/" element={<ExtrasList />} />
                <Route path="/budget/:token/" element={<Budget />} />
                <Route path="/v2/search/:lang/:origin/:session/:checkIn/:checkOut/:destType/:destId/" element={<Navigate to="/v3/search/:lang/:origin/:session/:checkIn/:checkOut/:destType/:destId/2-0-0/" />} />
                {(process.env.NODE_ENV === 'development') && (
                  <Route path="/dev" element={<TestPage />} />
                )}
                <Route path="*" element={<Navigate to="/" />} />
                {/* eslint-enable max-len */}
            </Routes>
          </Base>
        </Router>
      </PersistGate>
    </Provider>
  );
const target = document.getElementById('app');
if (target) {
  const root = ReactDOM.createRoot(target);
  root.render(<App />);
}
